import React from 'react';
import DOMPurify from 'isomorphic-dompurify';

export const purifySettings = {
    KEEP_CONTENT: false,
    FORBID_TAGS: ['style', 'img'],
    FORBID_ATTR: ['style']
};

const SafeInnerHTML = ({ as = 'div', html = '' }) => {
    const Comp = as;
    if (!html) return null;

    return <Comp dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html, purifySettings) }} />;
};

export default SafeInnerHTML;
